// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"NM-z","upvoteIcon":"OM-z","downvoteIcon":"PM-z","feedbackIcon":"QM-z"};